<h2 mat-dialog-title>Gelöschten Realm entfernen</h2>
<mat-dialog-content class="mat-typography">
  <span>
    Soll der bereits GDPR gelöschte Realm
    <b>{{ this.data.tenantIdentifier }}</b> mit der id
    <b>{{ this.data.tenantId }}</b> wirklich entfernt werden?
  </span>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Abbrechen</button>
  <button mat-button color="warn" (click)="removeRealmClicked()">
    Entfernen
  </button>
</mat-dialog-actions>
